module.exports = __webpack_public_path__ + "img/SO.b6907d05.svg";